<template>
  <div>
    <div class="container-fluid bg-custom min-vh-auto py-1">
      <div class="card custom-card shadow-lg p-4 w-100">
        <h2 class="text-center text-light fw-bold mb-1">Products</h2>
        <div class="mb-1">
          <label class="form-label text-light">Upload CSV File</label>
          <div class="input-group">
            <input
              type="file"
              accept=".csv"
              class="form-control"
              @click="resetFileInput"
              @change="handleFileUpload"
              ref="fileInput"
            />

            <div v-if="loader" class="text-center my-4 loader-overlay">
              <div class="fancy-loader"></div>
            </div>
            <button class="btn btn-primary" :disabled="!file || isLoading  || uploadAttempted" @click="uploadCsv">
              <i class="fas fa-upload"></i> Upload
            </button>
          </div>
          <p v-if="errorMessage" class="alert alert-danger mt-3" style="text-align: left">
            <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
          </p>
          <div
            v-if="isLoading"
            class="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
            style="background-color: rgba(0, 0, 0, 0.6); z-index: 1050"
          >
            <div class="text-center text-white">
              <div
                class="spinner-border text-light"
                role="status"
                style="width: 4rem; height: 4rem"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-4 mb-0 fw-bold" style="font-size: 1.5rem">
                Processing CSV file, please wait...
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="input-group mb-2 search-wrapper">
        <span class="input-group-text bg-gradient text-white">
          <i class="fas fa-search" style="color: black"></i>
        </span>

        <input
          type="text"
          class="form-control"
          placeholder="Search"
          v-model="getsearch"
          @input="onSearchInput"
        />

        <button @click="searchTerm1" :disabled="!getsearch.trim()" class="btn btn-primary">Search</button>
      </div>

      <div class="mt-2 d-flex justify-content-between align-items-center mb-2">
        <!-- Left side: Delete Button -->
        <div class="d-flex align-items-center">
          <h3 class="mb-0">
            <button
              @click="deletemodal"
              class="btn btn-sm btn-danger d-flex justify-content-center text-center"
              :disabled="selectedRows.length === 0"
            >
              <i
                class="fas fa-trash-alt"
                style="font-size: 15px; width: 12px; height: 12px"
              ></i>
            </button>
          </h3>
        </div>

        <div class="d-flex justify-content-end">
          <AddProducts @product-added="fetchProducts" />
        </div>
      </div>
     <!--  <div
        class="scroll-wrapper scroll-top"
        ref="topScroller"
        @scroll="syncScroll('top')"
      >
        <div class="scroll-inner" :style="{ width: scrollWidth + 'px' }"></div>
      </div> -->
      <div
        class="table-responsive scroll-wrapper scroll-bottom"
        ref="tableScrollContainer"
      
      >  <!--  @scroll="syncScroll('bottom')" --> 
        <table class="table table-bordered table-hover text-white align-middle">
          <thead class="table-dark">
            <tr>
              <th class="text-nowrap">
                <input type="checkbox" @change="toggleSelectAll" v-model="selectAll" />
              </th>
              <th
                v-for="(label, key) in filteredColumnMap"
                :key="key"
                class="text-nowrap"
              >
                {{ label }}
              </th>
              <th class="text-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filteredData.length === 0 && getsearch">
              <td
                :colspan="Object.keys(filteredColumnMap).length + 2"
                class="text-center text-danger"
              >
                No record found
              </td>
            </tr>
            <tr v-for="(product, index) in filteredData" :key="product.sku || index">
              <td>
                <input type="checkbox" v-model="selectedRows" :value="product.id" />
              </td>
              <td
                v-for="(label, key) in filteredColumnMap"
                :key="key"
                class="text-nowrap align-middle text-truncate position-relative"
                :style="getTdStyle(key)"
                 @mouseenter="onCellMouseEnter(key, product[key], $event)"
                 @mouseleave="onCellMouseLeave"
                >
                {{ key === 'contains_nicotine'
                ? (product[key] === 'Y' ? 'Yes' : product[key] === 'N' ? 'No' : '')
                : product[key] }}

                </td>
              <td class="text-nowrap align-middle">
                <div class="d-flex gap-2">
                  <button
                    class="btn btn-warning btn-sm me-2"
                    @click="openUpdateModal(product)"
                  >
                    <i class="fas fa-edit"></i>
                  </button>

                  <button
                    class="btn btn-sm btn-danger"
                    @click="deletemodalforsingle(product.id)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
     
      </div>
   
      <div
             v-if="tooltipVisible"
             class="custom-tooltip"
             :style="{
             top: tooltipPosition.top + 'px',
             left: tooltipPosition.left + 'px',
           }"
             @mouseenter="onTooltipMouseEnter"
             @mouseleave="onTooltipMouseLeave"
           >
           {{ tooltipContent }}
            </div>


      <p style="color: white; text-align: right" class="mt-1 mb-1">
        Total Rows : {{ totalSearchCount }}
      </p>

      <div
        class="mt-2 d-flex justify-content-end align-items-center text-light mb-3 position-static"
      >
        <div class="d-flex align-items-center">
          <label class="me-2 mb-0">Rows per page:</label>
          <select
            class="form-select d-inline-block w-auto me-3"
            v-model="pageSize"
            @change="changePageSize"
          >
            <option v-for="size in [10, 20, 25, 50, 100]" :key="size" :value="size">
              {{ size }}
            </option>
          </select>

          <button
            class="btn btn-secondary me-2"
            :disabled="currentPage === 1"
            @click="currentPage-- && fetchProducts()"
          >
            −
          </button>

          <span class="text-white">Page {{ currentPage }}</span>

          <button
            class="btn btn-secondary ms-2"
            :disabled="products.length < pageSize"
            @click="currentPage++ && fetchProducts()"
          >
            +
          </button>
          <input
            type="number"
            v-model.number="goToPageInput"
            @keyup.enter="goToPage"
            class="form-control ms-3"
            style="width: 80px"
            min="1"
            :max="totalPages"
            placeholder="Go to"
          />
        </div>
      </div>
    </div>
    <div class="modal fade" ref="csvModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload Successful</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body text-success">
            {{ successmsg }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="closeModal">OK</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="logoutModal1" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirm Delete</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>
          Are you sure you want to delete this 
         {{ selectedRows.length > 1 ? 'products' : 'product' }}?
           </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              class="btn btn-danger"
              @click="deleteSelectedProducts"
              data-bs-dismiss="modal"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Confirmation Modal -->
    <div class="modal fade" id="logoutModal12" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirm Delete</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure you want to delete this product
              <!--  <strong>{{ selectedProductId }}</strong -->
              ?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          
            <button 
               type="submit" 
               class="btn btn-sm btn-danger"
              @click="deletesingleProducts(selectedProductId)"
              :disabled="isDeleting"
               data-bs-dismiss="modal"
              >
          
              <span v-if="isDeleting">Deleting...</span>
              <span v-else>Deleting</span>
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Product  -->
    <div class="modal fade" id="Editproducts" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content custom-modal">
          <div class="modal-header">
            <h5 class="modal-title">Edit Product</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <!--   <div v-if="loader" class="text-center my-4 loader-overlay">
            <div class="fancy-loader"></div>
          </div> -->

          <div class="modal-body">
            <form @submit.prevent="submitEditProduct">
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">SKU *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editedProduct.sku"
                    placeholder="SKU"
                    required
                  />
                  <small v-if="skuerror" class="text-center text-danger"
                    >{{ skuerror }}
                  </small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">SKU Category</label>
                  <select v-model="editedProduct.sku_category" class="form-control">
                    <option value="" disabled>Select a Category</option>
                    <option v-for="cat in categories" :key="cat.id" :value="cat.name">
                      {{ cat.name }}
                    </option>
                  </select>
                </div>
                
                <div class="col-md-4">
                  <label class="form-label">Product Name *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editedProduct.product_name"
                    placeholder="Product Name "
                    required
                  />
                  <small class="text-center text-danger" v-if="ProductError"> {{ ProductError }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Brand </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editedProduct.brand_name"
                    placeholder="Product Brand"
                  />
                  <small class="text-center text-danger" v-if="BrandError"> {{ BrandError }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Sale Price *</label>
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model="editedProduct.sale_price"
                    placeholder="Sale Price"
                    required
                  />
                  <small v-if="SalePriceError" class="text-danger">{{
                   SalePriceError
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Cost Price *</label>
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model="editedProduct.cost_price"
                    placeholder="Cost Price "
                    required
                  />
                    <small v-if="CostPriceError" class="text-danger">{{
                   CostPriceError
                  }}</small>
                </div>
                <div class="col-md-4">
                <label class="form-label">LSU UOM</label>
                <select class="form-control"  v-model="editedProduct.lsu_uom">
                <option value="">-- Select / Clear Option --</option>
                <option value="Packs">Packs</option> 
                <option value="Eaches">Eaches</option>
                <option value="Milliliters">Milliliters (ML)</option>
                </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Factor</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="editedProduct.lsu_factor"
                    placeholder="LSU Factor"
                  />
                   <small v-if="LsuFactorError" class="text-danger">{{
                   LsuFactorError
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Weight</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="editedProduct.lsu_weight"
                    placeholder="LSU Weight"
                     step="any"
                  />
                      <small v-if="LsuWeightError" class="text-danger">{{
                   LsuWeightError
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Weight UOM</label>
                 <select  class="form-control" v-model="editedProduct.lsu_weight_uom">
                  <option value="">-- Select / Clear Option --</option>
                   <option value="Ounces" >Ounces</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Volume</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="editedProduct.lsu_volume"
                    placeholder="LSU Volume"
                    step="any"
                  />
                   <small v-if="LsuVolumeError" class="text-danger">{{
                   LsuVolumeError
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Volume UOM</label>
                 <select  class="form-control" v-model="editedProduct.lsu_volume_uom" >
                  <option value="">-- Select / Clear Option --</option>
                  <option value="Milliliters"> 	Milliliters (ML) </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Contains Nicotine</label>
                  <select v-model="editedProduct.contains_nicotine" class="form-control">
                    <option value="" disabled>Select a option</option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Unit Volume</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="editedProduct.unit_volume"
                    placeholder="Unit Volume"
                    step="any"
                  />
                    <small v-if="UnitVolumError" class="text-danger">{{
                   UnitVolumError
                  }}</small>
                </div>
                <div class="col-md-4">
                <label class="form-label">Unit Volume UOM</label>
                <select class="form-control"  v-model="editedProduct.unit_volume_uom">
                  <option value="">-- Select / Clear Option --</option>
                <option value="Milliliters">	Milliliters (ML)</option>
               </select>
               </div>
                <div class="col-md-4">
                  <label class="form-label">Distro</label>
                  <select v-model="editedProduct.distro" class="form-control">
                    <option value="" disabled>Select a Option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Customer</label>
                  <select   v-model="editedProduct.customer" class="form-control">
                    <option value="" disabled>Select an option </option>
                    <option value="Yes" >  Yes</option>
                     <option value="No"> No </option>
                     </select>
                </div>
              </div>
              <div class="text-end mt-1">
                <button
                class="btn btn-primary w-100 mt-3"
                :disabled="Editloader || (!editedProduct) || !isProductModified()"
                 >
                 Update Product
                 </button>
              </div>
              <div v-if="Editloader" class="text-center my-4 loader-overlay">
              <div class="fancy-loader"></div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { GetCategories } from "../End Points/api";
import {
  GetPaginatedProductList,
  UploadProductCSVfile,
  MultiplesDeletedProduct,
  DeletsingleProduct,
  UpdateProduct,
} from "../End Points/api";
import AddProducts from "./Products/AddProducts.vue";
export default {
  components: {
    AddProducts,
  },
  data() {
    return {
       uploadAttempted: false, 
      tooltipVisible: false,
      isDeleting: false,
    tooltipContent: '',
    tooltipPosition: { top: 0, left: 0 },
    hideTooltipTimeout: null, 
    // Track if mouse is over cell or tooltip
    mouseOverCell: false,
    mouseOverTooltip: false,
      skuerror: "",
      ProductError: "",
      BrandError:"",
      SalePriceError: "",
      CostPriceError: "",
      LsuUomError: "",
      LsuFactorError: "",
      LsuWeightError: "",
      LsuWeightUomError: "",
      LsuVolumeError: "",
      LsuVolumeUomError: "",
      UnitVolumError: "",
      UnitVolumeUomError: "",
      Editloader: false,
      file: null,
      errorMessage: "",
      isLoading: false,
      currentPage: 1,
      pageSize: 10,
      products: [],
      successmsg: "",
      searchTerm: "",
      getsearch: "",
      totalSearchCount: null,
      tableScrollWidth: 0,
      filteredData: 0,
      selectedProductId: null,
      editedProduct: {},
      categories: {},
      errorMsg: {},
      scrollWidth: 0,
      goToPageInput: 1,
      loader: false,
      dup_sale_price: "",
      columnMap: {
        id: "id",
        sku: "SKU",
        sku_category: "Category",
        product_name: "Product Name",
        brand_name:"Brand",
        sale_price: "Sale Price",
        cost_price: "Cost Price",
        lsu_uom: "Unit of Measure",
        lsu_factor: "LSU Factor",
        lsu_weight: "LSU Weight",
        lsu_weight_uom: "Weight UOM",
        lsu_volume: "LSU Volume",
        lsu_volume_uom: "Volume UOM",
        contains_nicotine: "Contain Nicotine",
        unit_volume: "Unit Volume",
        unit_volume_uom: "Unit Volume UOM",
        distro: "Distro",
        customer: "Customer",
       
      },
      selectedRows: [],
      selectAll: false,
    };
  },
  computed: {
    isProductChanged() {
    return JSON.stringify(this.editedProduct) !== JSON.stringify(this.originalEditedProduct);
  },
    filteredColumnMap() {
      const filtered = {};
      for (let key in this.columnMap) {
        if (key !== "id") {
          filtered[key] = this.columnMap[key];
        }
      }
      return filtered;
    },
    totalPages() {
      return this.totalSearchCount && this.pageSize
        ? Math.ceil(this.totalSearchCount / this.pageSize)
        : 1;
    },
  },

mounted() {
  this.fetchProducts();
  this.updateScrollWidth();
},
watch: {
  filteredData() {
    this.updateScrollWidth();
  }
},
  methods: {

    truncateText(text, maxLength) {
    if (!text || typeof text !== 'string') return '';
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  },

  getTdStyle(key) {
    return `
      max-width: ${key === 'product_name' ? '500px' : '200px'};
      overflow: hidden;
      cursor: pointer;
    `;
  },

  onCellMouseEnter(key, fullValue, event) {
  if (this.hideTooltipTimeout) {
    clearTimeout(this.hideTooltipTimeout);
    this.hideTooltipTimeout = null;
  }

  const el = event.target;
  /* const limit = key === 'product_name' ? 60 : 15; */

  const isOverflowing = el.scrollWidth > el.clientWidth;
/*   const isTextLong = typeof fullValue === 'string' && fullValue.length > limit; */

  if (isOverflowing) {
    this.tooltipContent = fullValue;

    const rect = el.getBoundingClientRect();
    const tooltipWidth = 500;
    const tooltipHeight = 250;
    const padding = 10;

  
    let left = rect.right;

    let top = rect.top + window.scrollY - 5;

    // Adjust horizontally if going out of viewport
    if (left + tooltipWidth > window.innerWidth) {
      left = rect.left - tooltipWidth - 10;
      if (left < padding) left = padding;
    }

    // Adjust vertically if going below
    if (top + tooltipHeight > window.scrollY + window.innerHeight) {
      top = window.scrollY + window.innerHeight - tooltipHeight - padding;
    }

    // Adjust vertically if going above
    if (top < window.scrollY + padding) {
      top = window.scrollY + padding;
    }

    this.tooltipPosition = { top, left };
    this.mouseOverCell = true;
    this.tooltipVisible = true;
  } else {
    this.tooltipVisible = false;
    this.mouseOverCell = false;
  }
},

  onCellMouseLeave() {
    this.mouseOverCell = false;
    this.scheduleTooltipHide();
  },

  onTooltipMouseEnter() {
    // Cancel hide timeout if any
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
      this.hideTooltipTimeout = null;
    }
    this.mouseOverTooltip = true;
  },

  onTooltipMouseLeave() {
    this.mouseOverTooltip = false;
    this.scheduleTooltipHide();
  },

  scheduleTooltipHide() {
    // Clear previous timer
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
      this.hideTooltipTimeout = null;
    }

    // Only hide if not over cell or tooltip after 100ms delay
    this.hideTooltipTimeout = setTimeout(() => {
      if (!this.mouseOverCell && !this.mouseOverTooltip) {
        this.tooltipVisible = false;
      }
      this.hideTooltipTimeout = null;
    }, 100);  // 100ms delay is enough to allow mouse crossing
  },
    resetFileInput() {
  this.$refs.fileInput.value = null;
      this.file = null;
      this.uploadAttempted = false;
   this.errorMessage = "";
},
     updateScrollWidth() {
    this.$nextTick(() => {
      setTimeout(() => {
        const table = this.$refs.tableScrollContainer;
        if (table) {
          const tableEl = table.querySelector("table");
          if (tableEl) {
            this.scrollWidth = tableEl.scrollWidth;
          }
        }
      }, 150); // Unified timing
    });
  },
 validateProductPrices() {
  // Clear previous errors
  this.skuerror = "";
   this.ProductError = "";
   this.BrandError = "";
  this.SalePriceError = "";
  this.CostPriceError = "";
  this.LsuUomError = "";
  this.LsuFactorError = "";
  this.LsuWeightError = "";
  this.LsuWeightUomError = "";
  this.LsuVolumeError = "";
  this.LsuVolumeUomError = "";
  this.UnitVolumError = "";
  this.UnitVolumeUomError = "";
  this.dup_sale_price = "";

  const {
    sku,
    product_name,
    brand_name,
    sale_price,
    cost_price,
    lsu_uom,
    lsu_factor,
    lsu_weight,
    lsu_weight_uom,
    lsu_volume,
    lsu_volume_uom,
    unit_volume,
    unit_volume_uom,
  } = this.editedProduct;

  let isValid = true;

  // SKU
  if (!sku) {
    this.skuerror = "SKU is required.";
    isValid = false;
  } else if (sku.toString().length > 255) {
    this.skuerror = "SKU length must be less than or equal to 255.";
    isValid = false;
  }
  if (brand_name && brand_name.length > 255) {
    this.BrandError = "Brand name must not exceed 255 characters.";
  isValid  = false
}
  // Product name
  if (!product_name || product_name.trim() === "") {
    this.ProductError = "Product name is required.";
    isValid = false;
  }  else if (product_name.length > 255) {
    this.ProductError = "Product name must be less than or equal to 255 characters.";
    isValid = false;
  } 

  const sale = parseFloat(sale_price);
  if (isNaN(sale)) {
    this.SalePriceError = "Sale price is required.";
    isValid = false;
  } else if (sale <= 0) {
    this.SalePriceError = "Sale price must be greater than 0.";
    isValid = false;
  } else if (sale > 999999) {
    this.SalePriceError = "Sale price must not exceed 999,999.";
    isValid = false;
  }

 
  const cost = parseFloat(cost_price);
  if (isNaN(cost)) {
    this.CostPriceError = "Cost price is required.";
    isValid = false;
  } else if (cost <= 0) {
    this.CostPriceError = "Cost price must be greater than 0.";
    isValid = false;
  } else if (cost > 999999) {
    this.CostPriceError = "Cost price must not exceed 999,999.";
    isValid = false;
  }

  
  if (!isNaN(sale) && !isNaN(cost) && sale < cost) {
    this.SalePriceError = "Sale price must be greater than or equal to cost price.";
    isValid = false;
  }
  if (lsu_uom && (typeof lsu_uom !== 'string' || lsu_uom.length > 255)) {
  this.LsuUomError = "LSU UOM must be a string with no more than 255 characters.";
  isValid = false;
}
this.editedProduct.lsu_factor = parseFloat(lsu_factor) || 0;
  if (this.editedProduct.lsu_factor < 0 || this.editedProduct.lsu_factor > 999999) {
    this.LsuFactorError = "LSU Factor must be between 0 and 999,999.";
    isValid = false;
  }

  this.editedProduct.lsu_weight = parseFloat(lsu_weight) || 0;
  if (this.editedProduct.lsu_weight < 0 || this.editedProduct.lsu_weight > 999999) {
    this.LsuWeightError = "LSU Weight must be between 0 and 999,999.";
    isValid = false;
  }

  this.editedProduct.lsu_volume = parseFloat(lsu_volume) || 0;
  if (this.editedProduct.lsu_volume < 0 || this.editedProduct.lsu_volume > 999999) {
    this.LsuVolumeError = "LSU Volume must be between 0 and 999,999.";
    isValid = false;
  }

  this.editedProduct.unit_volume = parseFloat(unit_volume) || 0;
  if (this.editedProduct.unit_volume < 0 || this.editedProduct.unit_volume > 999999) {
    this.UnitVolumError = "Unit Volume must be between 0 and 999,999.";
    isValid = false;
  }
 
  if (lsu_weight_uom && lsu_weight_uom.length > 255) {
    this.LsuWeightUomError = "LSU Weight UOM must be less than or equal to 255 characters.";
    isValid = false;
  }
  
  
  if (lsu_volume_uom && lsu_volume_uom.length > 255) {
    this.LsuVolumeUomError = "LSU Volume UOM must be less than or equal to 255 characters.";
    isValid = false;
  }


  
  if (unit_volume_uom && unit_volume_uom.length > 255) {
    this.UnitVolumeUomError = "Unit Volume UOM must be less than or equal to 255 characters.";
    isValid = false;
   }
    if (unit_volume && (isNaN(unit_volume) ||unit_volume  < 0 || unit_volume > 999999)) {
    this.UnitVolumError = "Unit Volume must be between 0 and 999,999.";
    isValid = false;
  }

  return isValid;
},


    goToPage() {
      const total = this.totalPages || 1;
      if (this.goToPageInput >= 1 && this.goToPageInput <= total) {
        this.currentPage = this.goToPageInput;
        this.fetchProducts();
      } else {
        this.errorToast(`Please enter a valid page between 1 and ${total}`);
      }
    },
    successToast(msg) {
      this.$toast.success(msg, { timeout: 4000 });
    },
    errorToast(msg) {
      this.$toast.error(msg, { timeout: 5000 });
    },
    async getCategories() {
      try {
        const res = await GetCategories();
        if (res && res.data) {
          this.categories = res.data;
          /*    console.log("categories", this.categories); */
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    openAddProductModal() {
      const modal = new bootstrap.Modal(document.getElementById("Addproducts"));
      modal.show();
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedRows = this.filteredData.map((p) => p.id);
        /*  console.log("the id is :", this.selectedRows); */
      } else {
        this.selectedRows = [];
      }
    },
    openModal() {
      if (!this.modalInstance) {
        this.modalInstance = new bootstrap.Modal(this.$refs.csvModal, {
          backdrop: "static",
          keyboard: false,
        });
      }
      this.modalInstance.show();
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    handleFileUpload(event) {
      const selectedFile = event.target.files[0];
      this.errorMessage = "";
      this.uploadAttempted = false;
      if (!selectedFile) {
        this.errorMessage = "Please select a file.";
        this.file = null;
        return;
      }
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (fileExtension !== "csv") {
        this.errorMessage = "Only CSV files are allowed.";
        this.file = null;
        this.$refs.fileInput.value = "";
        return;
      }
      this.file = selectedFile;
  
    },
    async uploadCsv() {
      this.errorMessage = "";
      if (!this.file) {
        this.errorMessage = "Please select a valid CSV file.";
        return;
      }
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append("file", this.file, this.file.name);
        const response = await UploadProductCSVfile(formData);
        if (response.status === 200) {
          console.log("CSV uploaded successfully.");
          this.successmsg = response.data.message;
          this.file = null;
          this.$refs.fileInput.value = "";
          this.fetchProducts();
          this.openModal();
        } else {
          this.errorMessage = "Error uploading file. Please try again.";
        }
      } catch (error) {
        console.error("Upload Error:", error);
        this.errorMessage = this.errorMessage = error.response.data.message;
         setTimeout(() => {
           this.errorMessage = ""
        },3000)
      } finally {
        this.isLoading = false;
        this.$refs.fileInput.value = "";
        this.file = null;
        this.uploadAttempted = true;
    
      }
    },
    async fetchProducts() {
      this.loader = true;
      try {
        const response = await GetPaginatedProductList(
          this.currentPage,
          this.pageSize,
          this.searchTerm
        );
        this.products = response.data.products.results;
        this.totalSearchCount = response.data.products.count;
        this.filteredData = this.products;
      } catch (error) {
        console.error("Failed to fetch products", error);
      } finally {
        this.loader = false;
      }
    },

    changePageSize() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    async searchTerm1() {
      const trimmed = this.getsearch.trim();
      if (!trimmed && !this.searchTerm) {
        return;
      }
      this.searchTerm = trimmed;
      this.currentPage = 1;
      await this.fetchProducts();
    },
    onSearchInput() {
      const trimmed = this.getsearch.trim();

      if (!trimmed && this.searchTerm) {
        this.searchTerm = "";
        this.currentPage = 1;
        this.fetchProducts();
      }
    },
    syncScroll(source) {
      const top = this.$refs.topScroller;
      const bottom = this.$refs.tableScrollContainer;

      if (source === "top") {
        bottom.scrollLeft = top.scrollLeft;
      } else {
        top.scrollLeft = bottom.scrollLeft;
      }
    },
    async deleteSelectedProducts() {
      if (this.isDeleting) return;
       this.loader = true
    
    this.isDeleting = true; 
      try {
        const response = await MultiplesDeletedProduct(this.selectedRows);

        if (response.status === 200) {
          const deletedCount = this.selectedRows.length;
          await this.fetchProducts();
          this.selectedRows = [];
          this.selectAll = false;
          const modal = new bootstrap.Modal(document.getElementById("logoutModal1"));
          modal.hide();
          if (deletedCount === 1) {
         this.successToast("Product has been deleted successfully");
      } else {
        this.successToast("Products have been deleted successfully");
      }
        
        }
      } catch (error) {
        console.error("Delete error:", error);
      }
      finally {
        setTimeout(() => {
        this.loader = false
        this.isDeleting = false;
      
      }, 500); 
      }
    },
 
    async deletesingleProducts(id) {
      if (this.isDeleting) return;
          this.loader = true
    
    this.isDeleting = true; 

    try {
      const response = await DeletsingleProduct(id);
      
      if (response.status === 200) {
        await this.fetchProducts(); 
        this.selectedRows = [];
        this.selectAll = false
        // Close modal safely
        const modalEl = document.getElementById("logoutModal12");
        const modalInstance = bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) {
          modalInstance.hide();
        }
        this.successToast("Product has been deleted successfully.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      this.errorToast("Invalid product ID");
    } finally {
         setTimeout(() => {
          this.loader = false
          this.isDeleting = false; 
         }, 500);
       
    }
  },

    deletemodal() {
      const modal = new bootstrap.Modal(document.getElementById("logoutModal1"));
      modal.show();
    },
    deletemodalforsingle(id) {
      this.prepareDeleteModal(id);
      /*  console.log("the id is ", id); */
      const modal = new bootstrap.Modal(document.getElementById("logoutModal12"));
      modal.show();
    },
    prepareDeleteModal(id) {
      this.selectedProductId = id;
    },
    openUpdateModal(product) {
      this.skuerror = "",
        this.ProductError = "",
        this.BrandError = "",
        this.SalePriceError = "",
        this.CostPriceError = "",
        this.LsuFactorError = "",
        this.LsuWeightError = "",
        this.LsuVolumeError = "",
        this.UnitVolumError = "",
      
      (this.errorMsg = {}), (this.successmsg = "");
      this.getCategories();
      this.originalEditedProduct = JSON.parse(JSON.stringify(product)); // store original
      this.editedProduct = JSON.parse(JSON.stringify(product));

      
     /*  this.editedProduct = { ...product }; */
      const modal = new bootstrap.Modal(document.getElementById("Editproducts"));
      modal.show();
    },
    isProductModified() {
  if (!this.originalEditedProduct || !this.editedProduct) {
    return false;
  }

  const normalize = (product) => ({
    ...product,
    sale_price: parseFloat(product.sale_price) || 0,
    cost_price: parseFloat(product.cost_price) || 0,
    lsu_factor: parseFloat(product.lsu_factor) || 0,
    lsu_weight: parseFloat(product.lsu_weight) || 0,
    lsu_volume: parseFloat(product.lsu_volume) || 0,
    unit_volume: parseFloat(product.unit_volume) || 0,
  });

  const original = normalize(this.originalEditedProduct);
  const edited = normalize(this.editedProduct);

  return JSON.stringify(original) !== JSON.stringify(edited);
},

    async submitEditProduct() {
      
      if (!this.validateProductPrices()) {
        return;
      }
      if (this.addRuleloader) return;

      this.dup_sale_price = "";
      this.errorMsg = {};
      this.successmsg = "";
      this.Editloader = true;
      this.skuerror = "";
      this.editedProduct.lsu_factor = parseFloat(this.editedProduct.lsu_factor) || 0;
      this.editedProduct.lsu_volume = parseFloat(this.editedProduct.lsu_volume) || 0;
      this.editedProduct.unit_volume = parseFloat(this.editedProduct.unit_volume) || 0;
      this.editedProduct.lsu_weight = parseFloat(this.editedProduct.lsu_weight) || 0;
      try {
      
        const response = await UpdateProduct(this.editedProduct.id, this.editedProduct);
       
        if (response.status === 200) {
          this.errorMsg = {};
          this.successmsg = "Product updated successfully!";
          this.successToast("Product updated successfully!");
          this.fetchProducts();
          const modalEl = document.getElementById("Editproducts");
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance.hide();
          }
        } else {
          this.successmsg = "Failed to update the product. Try again.";
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          this.successmsg = "";

          /*  this.skuerror =error.response.data.errors; */
          this.skuerror = error.response.data.errors.sku[0];
        /*   console.log("the error is ",this.skuerror) */
          /*  const modalEl = document.getElementById("Editproducts");
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance.hide();
          } */
        } /*  else {
          this.errorMsg = error.message || "An unknown error occurred.";
          this.errorToast(this.errorMsg);
        } */
        console.error("Update error:", error);
      } finally {
        setTimeout(() => {
          this.Editloader = false;
        }, 500);
        
      }
    },
  },
};
</script>
<style scoped>
.bg-custom {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
}

.custom-card {
  background: transparent;
  color: white;
  border-radius: 15px;
  border: none;
}

.form-control,
.btn {
  border-radius: 10px;
  padding: 10px;
}
.btn-primary {
  background-color: #007bff;
  border: none;
}
.btn-primary:hover {
  background-color: #0056b3;
}
.btn-warning {
  background-color: #f0ad4e;
  border: none;
}
.btn-warning:hover {
  background-color: #ec971f;
}
.error-message {
  font-size: 16px;
  color: #721c24;
  background-color: #f8d7da;
  padding: 10px 15px;
  border-radius: 6px;
  border-left: 5px solid #dc3545;
}

.search-wrapper {
  max-width: 100%;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .custom-modal {
    width: 100%;
    height: 95vh;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}
@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.scroll-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}

.scroll-top {
  height: 16px;
  margin-bottom: 6px;
}

.scroll-inner {
  height: 1px;
  background: transparent;
}

.toast-success {
  background-color: #28a745;
}

.toast-error {
  background-color: #dc3545;
  color: white;
}
.custom-modal {
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
  padding: 1rem;
  border-radius: 1rem;
  margin: auto;
}
.modal-content {
  width: 80%;
  max-width: 80%;
}

.custom-tooltip {
  position: absolute;
  z-index: 9999;
  background: #fff;
  color: #000;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  max-width: 500px;
  max-height: 250px;
  overflow-y: auto;
  white-space: pre-wrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-size: 0.875rem;
  pointer-events: auto;
  word-break: break-word;
}








</style>
   